module.exports = __webpack_public_path__ + "static/img/danMuClose.383cc8f4.png";